export default __webpack_public_path__ + "static/media/afrolit.e5405c81.jpg";